<template>
  <swiper
    ref="hoop"
    v-if="carousels"
    class="carousels mx-auto"
    :options="hooperSettings"
  >
    <swiper-slide
      class="silde-css"
      v-for="slide in carousels"
      :key="slide.id"
      :data-id="slide.id"
    >
      <div
        class="carousels-img relative cursor-pointer w-full"
        :style="'background-image: url(' + slide.image_url + ');'"
      >
        <!-- <div class="hooper-font absolute cursor-default">
          <div class="hooper-font-title">{{ slide.title }}</div>
          <div class="hooper-font-content">{{ slide.description }}</div>
        </div> -->
      </div>
    </swiper-slide>

    <div class="swiper-pagination" slot="pagination"></div>
    <div
      class="swiper-button-prev swiper-button-white"
      slot="button-prev"
    ></div>
    <div
      class="swiper-button-next swiper-button-white"
      slot="button-next"
    ></div>
  </swiper>
</template>

<script>
// import { clickedOnCarousel } from '@/core/api'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'CarouselsComponent',
  props: {},
  mixins: [],
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      hooperSettings: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        // effect: 'fade',
        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    carousels() {
      // let data = this.$store.getters['CarouselsStore/carousels']
      // if (data === false) {
      //   return false
      // }
      let data = [
        { id: 1, image_url: '/static/images/carousels/1.jpeg' },
        { id: 2, image_url: '/static/images/carousels/2.jpeg' },
        { id: 3, image_url: '/static/images/carousels/3.jpeg' }
      ]

      return data
    }
  },
  mounted() {
    // swiper loop:true时，复制的dom绑定不上事件，现用js绑定-----begin-----
    let _this = this
    var slides = document.querySelectorAll('.silde-css')
    slides.forEach(item => {
      item.onclick = function() {
        let res = _this.carousels.filter(v => v.id + '' === item.dataset.id)
        if (res && res.length) _this.carouselsLink(res[0])
      }
    })
    // swiper loop:true时，复制的dom绑定不上事件，现用js绑定-----end-----
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    async carouselsLink(item) {
      this.$router.push({ name: 'waiting' })
      // let res = await clickedOnCarousel(item.id, { scope: 'web' })
      // // console.log(res.data) // eslint-disable-line no-console
      // if (res.status === 200) {
      //   let data = res.data

      //   if (data.link_type && data.link_value) {
      //     let obj = {}
      //     obj.category = data.link_category

      //     if (data.link_category && data.link_type === 'article') {
      //       obj.type = data.link_type
      //       obj.id = data.link_value
      //       obj.pId = 'document'
      //     } else if (data.link_type === 'panorama') {
      //       obj.type = 'link'
      //       obj.link = '/' + data.link_type + '/h5'
      //       obj.query = { id: data.link_value }
      //     } else if (data.link_type === 'ceramic') {
      //       obj.type = 'link'
      //       obj.link = '/' + data.link_type
      //       obj.query = { uuid: data.link_value }
      //     } else if (data.link_type === 'video') {
      //       if (data.link_value && data.link_value !== '') {
      //         obj.type = 'info'
      //       }
      //       obj.id = data.link_value
      //     } else if (data.link_type === 'other') {
      //       obj.type = 'link'
      //       obj.link = data.link_value
      //     }

      //     this.link(obj, 'windowOpen')
      //   } else {
      //     console.log('无法跳转') // eslint-disable-line no-console
      //   }
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.carousels {
  height: 31.25vw; //600px;
  /deep/ .swiper-wrapper {
    height: 31.25vw; //600px;
  }
  /deep/ .swiper-slide {
    height: 31.25vw; //600px;
    // margin-right: 0 !important;
  }
  .carousels-img {
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  // 修改轮播图样式
  /deep/ .swiper-pagination {
    bottom: 1.875vw; //36px;

    .swiper-pagination-bullet {
      width: 0.68vw; //13px;
      height: 0.68vw; //13px;
      background-position: center;
      background-repeat: no-repeat;
      background-color: $c-transparent-l-9;
      margin: 0 0.78vw; //15px;
      &.swiper-pagination-bullet-active {
        background-color: $c-white;
      }
    }
  }
  // /deep/ .swiper-button-prev,
  // /deep/ .swiper-button-next {
  //   width: 45px;
  //   height: 45px;
  //   background-position: center;
  //   background-repeat: no-repeat;
  //   background-size: contain;
  //   background-color: $c-transparent;
  //   svg {
  //     display: none;
  //   }
  // }
  // /deep/ .swiper-button-prev {
  //   background-image: url('/static/images/icons/hooper-prev.png');
  //   margin-left: 20px;
  // }
  // /deep/ .swiper-button-next {
  //   background-image: url('/static/images/icons/hooper-next.png');
  //   margin-right: 20px;
  // }
  // .hooper-font {
  //   box-sizing: border-box;
  //   height: 145px;
  //   background-color: $c-transparent-nav-list;
  //   padding: 30px 30px 0 44px;
  //   bottom: 0;
  //   left: 0;
  //   right: 0;
  //   line-height: 1;
  //   .hooper-font-title {
  //     font-size: 1.875vw; //36px;
  //     color: $c-black;
  //     padding-bottom: 12px;
  //     overflow: hidden;
  //     -o-text-overflow: ellipsis; /* Opera 9-10 */
  //     text-overflow: ellipsis;
  //     white-space: nowrap;
  //   }
  //   .hooper-font-content {
  //     font-size: 18px;
  //     line-height: 1.3;
  //     color: $c-black;
  //     width: 60%;
  //     -o-text-overflow: ellipsis; /* Opera 9-10 */
  //     text-overflow: ellipsis;
  //     white-space: wrap;
  //     display: -webkit-box;
  //     overflow: hidden;
  //     -webkit-box-orient: vertical;
  //     -webkit-line-clamp: 2;
  //   }
  // }
}
</style>
